import { defaultCountries, type CountryData } from 'react-international-phone';

const flagSelectTerritories: CountryData[] = [
    ['American Samoa', 'as', '1684'],
    ['Anguilla', 'ai', '1264'],
    ['Bermuda', 'bm', '1441'],
    ['British Virgin Islands', 'vg', '1284'],
    ['Cook Islands', 'ck', '682'],
    ['Falkland Islands', 'fk', '500'],
    ['Gibraltar', 'gi', '350'],
    ['Jersey', 'je', '44', '.... ......'],
    ['Montserrat', 'ms', '1664'],
    ['Niue', 'nu', '683'],
    ['Norfolk Island', 'nf', '672'],
    ['Northern Mariana Islands', 'mp', '1670'],
    ['Saint Barthélemy', 'bl', '590', '', 1],
    ['Saint Helena', 'sh', '290'],
    ['Saint Martin', 'mf', '590', '', 2],
    ['Sint Maarten', 'sx', '1721'],
    ['Tokelau', 'tk', '690'],
    ['Turks and Caicos Islands', 'tc', '1649'],
    ['U.S. Virgin Islands', 'vi', '1340']
];

const mergeCountriesRemovingDuplicates = (
    countriesA: CountryData[],
    countriesB: CountryData[]
): CountryData[] =>
    Array.from(new Map([...countriesA, ...countriesB].map((c) => [c[1], c])).values());

export const flagSelectCountries: CountryData[] = mergeCountriesRemovingDuplicates(
    defaultCountries,
    flagSelectTerritories
);
